__turbopack_context__.v({
  "reset": "GlobalAthletesLeaderboard-module-scss-module__XopUva__reset",
  "resetIcon": "GlobalAthletesLeaderboard-module-scss-module__XopUva__resetIcon",
  "root": "GlobalAthletesLeaderboard-module-scss-module__XopUva__root",
  "toolbar": "GlobalAthletesLeaderboard-module-scss-module__XopUva__toolbar",
});
